import React from "react";
import cns from "classnames";
import { ThemeType } from "@theme";
import { Option } from "./utils";
import { makeStyles } from "@material-ui/core/styles";

type Props = {
  disabled?: boolean;
  id: string;
  instancePrefix: string;
  label?: string;
  onClick: (value: string | Option) => any;
  onRemove: (value: string | Option) => any;
  placeholder: string;
  value: string | Option;
};

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    "&:not(:last-child)": {
      marginRight: theme.spacing(1 / 2)
    },

    "&:not(:nth-last-child(2)):after": {
      content: "', '",
      display: "inline-block"
    }
  },

  error: {
    color: theme.palette.error.main
  }
}));

export function SelectValuePlain(props: Props) {
  const classes = useStyles({});
  const classNames = cns(classes.root, {
    [classes.error]: typeof props.value === "object" && props.value.error
  });

  return (
    <div className={classNames} tabIndex={-1}>
      {props.label}
    </div>
  );
}
